import React, { memo } from "react";

import addedToCart from "/images/checkmark.svg";

interface ProductDetailsProps {
  image: string;
  title: string;
  currentPrice: string;
  originalPrice?: string;
  onYesClick: () => void;
  onNoClick: () => void;
  isAddedToCart?: boolean;
}

export const ProductDetails = memo(function ProductDetails({
  image,
  title,
  currentPrice,
  originalPrice,
  onYesClick,
  onNoClick,
  isAddedToCart = false,
}: ProductDetailsProps) {
  return (
    <div className="results-cart">
      <div className="flex justify-center w-full h-[158px] max-h-[158px] rounded-[8px] overflow-hidden">
        <img
          src={image}
          alt="cart item"
          className=" max-w-full h-auto max-h-full object-contain rounded-[8px] object-center"
        />
      </div>
      <div className="results-cart-text mt-[7px]">
        <p className="mb-[7px] text-[14px] [@media(max-width:440px)]:text-[13px]">
          {title}
        </p>
        <div className="flex items-center gap-[6px]">
          <p className="text-[#797AFF] text-[16px] [@media(max-width:440px)]:text-[14px]">
            {currentPrice}
          </p>
          {originalPrice && (
            <p className="text-[#9E9E9E] text-[16px] [@media(max-width:440px)]:text-[14px]">
              <del>{originalPrice}</del>
            </p>
          )}
        </div>
      </div>
      <p className="widget-displaying-results__title text-[16px] leading-[150%] tracking-[0%] text-center mt-[20px] mb-[20px]">
        Would you like me to add this item to your cart?
      </p>
      <div className="results-cart-buttons w-[100%] pb-[16px] flex items-center justify-between mt-[16px] gap-[16px]">
        <button
          className="cursor-pointer w-[172px] h-[52px] rounded-[1023px] flex items-center justify-center p-[1px]"
          onClick={onNoClick}
        >
          <span className="inline-block w-[100%] h-[100%] flex items-center justify-center bg-white rounded-[1023px]">
            No
          </span>
        </button>
        <button
          className={`cursor-pointer w-[172px] h-[52px] rounded-[1023px] flex items-center justify-center text-white ${isAddedToCart ? "checked-button" : ""}`}
          onClick={onYesClick}
        >
          {isAddedToCart ? (
            <img
              src={addedToCart}
              alt="added to cart"
              className="w-[24px] h-[24px]"
            />
          ) : (
            "Yes"
          )}
        </button>
      </div>
    </div>
  );
});
